module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-collapse"
  }, [_c('div', {
    staticClass: "rt-collapse-header",
    on: {
      "click": _vm.collapseClick
    }
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.showContent ? 'rt-base-angle_up' : 'rt-base-angle_down',
      "size": "18"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "rt-collapse-content"
  }, [_c('rt-collapse-transition', [
    [_vm._t("default")]
  ], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a8f245f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/collapse/rtCollapse.vue
// module id = 1515
// module chunks = 91